import { useContext, useMemo } from 'react';

import NavSelect from '@/components/select/NavSelect';
import AppContext from '@/contexts/appContext';
import { useNarrowNav } from '@/contexts/narrowNavContext';
import { getAvailableWorkspaceNavOptions } from '@/utils/workspaceNavOptions';

/**
 * The workspace's pages as a `<select>`, the narrow layout's original navigation.
 *
 * Superseded by the drawer behind the top bar's menu button, and rendered only for people who
 * have asked for the dropdown back in Dugout Settings.
 */
const MyWorkspaceNav = () => {
  const { navStyle } = useNarrowNav();
  const { permissions } = useContext(AppContext);

  const navOptions: { [key: string]: string } = useMemo(
    () =>
      getAvailableWorkspaceNavOptions(permissions).reduce(
        (options, option) => {
          options[option.label] = option.path;
          return options;
        },
        {} as { [key: string]: string }
      ),
    [permissions]
  );

  const selectedValue = useMemo(() => {
    const path = location.pathname.replace('/agent', '');

    const match = Object.entries(navOptions).find((option) => option[1] === path);

    if (match) {
      return match[0];
    }

    if (path === '') {
      return 'My People';
    }

    return 'default';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navOptions, location.pathname]);

  if (navStyle !== 'select') return null;

  return (
    <nav className="px-2 py-1">
      <NavSelect
        defaultOption={{ label: '...', value: 'default' }}
        navOptions={navOptions}
        selectedValue={selectedValue}
      />
    </nav>
  );
};

export default MyWorkspaceNav;
